import useLocalStorageState from 'use-local-storage-state'

export const useAuthTimeStamp = () => {
	return useLocalStorageState('Granlupo-auth-timeStamp', { defaultValue: 0 })
}
